// Mirrors the hero-image resolution used by the share-image generator
// (app/api/og/post/[slug]/route.tsx) so the "add a photo" prompt in
// PostShareModal only fires when the shared image would actually have no
// photo — not just when the Tiptap content itself lacks an <img> tag.
function extractFirstImageFromContent(html?: string | null): string | null {
  if (!html) return null
  const match = html.match(/<img[^>]+src=["']([^"']+)["']/i)
  return match?.[1] || null
}

export function postHasHeroImage(post: {
  content?: string | null
  post_medias?: ({ url?: string | null } | null)[] | null
  post_products?: ({ product?: { mainImage?: string | null } | null } | null)[] | null
}): boolean {
  const hasMedia = !!post?.post_medias?.some((m) => m?.url)
  const hasContentImage = !!extractFirstImageFromContent(post?.content)
  if (hasMedia || hasContentImage) return true

  const productsWithImage = (post?.post_products || [])
    .map((pp) => pp?.product)
    .filter((p) => !!p?.mainImage)
  return productsWithImage.length === 1
}
